export const KAKAO_SERVICE = {
  plusfriend: {
    name: 'plusfriend',
    text: '카카오톡 채널',
  },
  talkstore: {
    name: 'talkstore',
    text: '톡스토어',
  },
  gift: {
    name: 'gift',
    text: '선물하기',
  },
}
